var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShurikens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 154,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.54 68.884s-9.743-.461-16.505 4.634c-6.607 4.979-9.003 14.589-9.003 14.589l-19.72 65.271-.255-.019 7.988-66.133s1.987-9.513-2.474-15.432c-4.46-5.92-14.152-6.631-14.152-6.631l-65.773-10.55.052-.251 68.178-.965s9.744.462 16.506-4.633c6.761-5.095 9.003-14.59 9.003-14.59l19.72-65.27.255.018-7.987 66.133s-1.987 9.513 2.473 15.432c4.46 5.92 14.152 6.632 14.152 6.632l65.721 10.8-68.178.965z",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShurikens);
export default __webpack_public_path__ + "static/media/shurikens.bed508c3c9c058497032177730d4dc0c.svg";
export { ForwardRef as ReactComponent };